import type { Directive } from 'vue'

type TrackExternalLinkParams = {
  cta: string
  isOwner?: boolean
} | undefined

export default defineNuxtPlugin((nuxtApp) => {
  const { routeBaseName } = useBaseName()
  const { userExists, userIsOwner } = useUser()

  const clickHandlers = new WeakMap<HTMLAnchorElement, (event: Event) => void>()

  function clickHandler({
    event,
    anchor,
    params,
  }: {
    event: Event
    anchor: HTMLAnchorElement
    params: TrackExternalLinkParams
  }) {
    trackExternalLinkClicked({
      externalLink: anchor.href,
      cta: params?.cta ?? '',
      pageSource: routeBaseName.value,
      isOwner: params?.isOwner ?? (userExists.value ? userIsOwner.value : null),
    })

    const protocol = anchor.protocol
    if (protocol === 'tel:' || protocol === 'mailto:') {
      return
    }

    event.preventDefault()
    window.open(anchor.href, anchor.target || '_blank')
  }

  nuxtApp.vueApp.directive('track-external-link', <Directive<HTMLAnchorElement, TrackExternalLinkParams>>{
    mounted(el, binding) {
      const handler = (event: Event) => clickHandler({
        event,
        anchor: el,
        params: binding.value,
      })

      clickHandlers.set(el, handler)
      el.addEventListener('click', handler)
    },

    unmounted(el) {
      const handler = clickHandlers.get(el)

      if (handler) {
        el.removeEventListener('click', handler)
        clickHandlers.delete(el)
      }
    },

    getSSRProps() {
      return {}
    },
  })
})
